export default "__VITE_ASSET__C8lzt5ML__"